<div class="container-fluid" id="dealership-holiday">
    <div class="row">
        <div class="col-md-12">
            <div class="page-title-con">
                <div class="page-title">
                    <span class="text-capitalize">{{ departmentTitleKey | translate }}</span>
                </div>
                <span class="holiday-spacer"></span>
                <div class="add-holiday">
                    <button class="add-holiday-btn" type="button" (click)="createHoliday()">
                        <span class="mr5">{{ 'departmentHolidays.addNewHoliday' | translate }}</span>
                    </button>
                </div>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-md-12">
             <div class="holiday-year">
                 <button *ngIf="currentYear !== activeYear" class="load-previous-year" type="button" (click)="loadPreviousYear()"> <asp-icon name="ic-20-utility-play-fill.svg"  color='var(--primary-sec-color)'></asp-icon></button>
                 <span class="pt3">{{activeYear}} {{ 'departmentHolidays.holidayList' | translate }}</span>
                 <button *ngIf="currentYear === activeYear" class="load-next-year" type="button" (click)="loadNextYear()"> <asp-icon name="ic-20-utility-play-fill.svg"  color='var(--primary-sec-color)'></asp-icon></button>
             </div>
        </div>
    </div>
    <div class="row">
        <div class="col-md-12">
            <div class="holiday-list-container">
                <app-holidays-list [holidays]='holidays$ | async '></app-holidays-list>
            </div>
        </div>
    </div>
</div>

